var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.user.permissions.security_show)?_c('div',{staticClass:"security"},[_c('BaseTable',{attrs:{"settings":_vm.settings,"fields":_vm.fields,"items":_vm.result,"searchTerm":_vm.$store.state.searchTerm,"colstripes":"","tableClass":"tableSecurity","sortBy":"right_desc","sortOrder":"asc","tableId":"1"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20252059","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Security.vue
// module id = 217
// module chunks = 1